import { Button, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Footer from "./Footer";
import Image from "../assets/BG.png";
import '../utils/effectCSS/Effects.css';
// import Video from "../assets/BG-Video2.mp4";

const Base = ({
  title = "Title",
  description = "description",
  buttonEnabled = false,
  buttonText = "Explore",
  buttonType = "primary",
  buttonLink = "/",
  children,
}) => {
  return (
    <div>
      <Container
        fluid
        className="p-5 text-white text-center d-flex justify-content-center align-items-center"
        style={{
          height: "515px",
          // This is how you give background image in style
          backgroundImage: "url(" + Image + ")",
          backgroundSize: "auto",
        }}
      >
        {/* <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "500px",
            objectFit: "cover",
            zIndex: -1,
            filter: "blur(1px)",
            WebkitFilter: "blur(1px)",
          }}
        >
          <source
            // src="https://dotnext.co.za/wp-content/uploads/2022/04/dotnext-hero-bg-video.mp4"
            src={Video}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video> */}
        <div>
          <div>
            <p
              className="text-center"
              style={{
                maxWidth: "700px",
                margin: "0 auto",
                fontSize: "1.5rem",
              }}
            >
              {description && description}
            </p>
          </div>

          <p
            className="text-center"
            style={{ maxWidth: "600px", marginTop: "3px" }}
          >
            {title}
          </p>

          {buttonEnabled && (
            <Button id="hover-change-color"
              as={NavLink}
              to={"/contact"}
              variant={buttonType}
            >
              {buttonText}
            </Button>
          )}
        </div>
      </Container>

      {children}
      <Footer />
    </div>
  );
};

export default Base;
